import { BaseModal } from '@theme/modal';

/**
 * @class VideoModal
 * @extends BaseModal
 *
 * Modal variant that pauses the video player on close.
 */
export class VideoModal extends BaseModal {
  /**
   * Keep the element at <body> after first open to prevent
   * Plyr from being destroyed and re-initialized on every open/close.
   */
  get persistAtBody() {
    return true;
  }

  get player() {
    return this.querySelector('video-player');
  }

  onClose() {
    this.player?.pause();
  }
}

if (!customElements.get('video-modal')) {
  customElements.define('video-modal', VideoModal);
}
